import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AgentTemplateResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getAgentTemplates } from './api';

export function useGetAgencyAgentTemplates(
  page: number,
  integration_code?: string,
  per_page?: number,
  options?: UseQueryOptions<{ data: AgentTemplateResponse[]; meta: MetaApiResponse }, Error>
) {
  return useQuery<{ data: AgentTemplateResponse[]; meta: MetaApiResponse }>({
    queryKey: ['agencyAgentTemplates', page, integration_code, per_page],
    queryFn: () => getAgentTemplates(page, integration_code, per_page),
    ...options
  });
}
